/**
 * @generated SignedSource<<31b8657f09b7a729f0bb61efdd7b5bb2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { UpdatableFragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type highlightIssueRow$data = {
  isHighlightedIssueRow: boolean | null | undefined;
  readonly " $fragmentType": "highlightIssueRow";
};
export type highlightIssueRow$key = {
  readonly " $data"?: highlightIssueRow$data;
  readonly $updatableFragmentSpreads: FragmentRefs<"highlightIssueRow">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "highlightIssueRow",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isHighlightedIssueRow"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "a9247a88904b4ab4be14f6ca46a6806e";

export default node;
